// Accounts.jsx
import { PageHeader, Card, Button, EmptyState } from '../components/UI'
import { useStore } from '../store/useStore'

export function Accounts() {
  const { plan, canUseFeature } = useStore()
  const atLimit = plan === 'free' // free = max 3 accounts (simplified check)

  return (
    <div>
      <PageHeader
        title="Accounts"
        subtitle="All your financial accounts in one place"
        action={
          atLimit
            ? <a href="/pricing" style={{ color: '#00C896', fontSize: 13, textDecoration: 'none' }}>Upgrade for unlimited accounts</a>
            : <Button>+ Connect Account</Button>
        }
      />
      <EmptyState
        icon="🏦"
        title="Connect your first account"
        description="Securely connect your bank accounts, credit cards, and investment accounts via Plaid. Read-only access — we can never move your money."
        action={<Button onClick={() => alert('Plaid Link would open here')}>Connect with Plaid</Button>}
      />
    </div>
  )
}

// Budget.jsx
export function Budget() {
  return (
    <div>
      <PageHeader title="Budget" subtitle="Track spending against your monthly targets" />
      <Card>
        <p style={{ color: '#6B8F7A', fontSize: 14 }}>Budget categories load from your transaction data. Connect accounts to get started.</p>
      </Card>
    </div>
  )
}

// Investments.jsx
export function Investments() {
  const { canUseFeature } = useStore()
  const { UpgradePrompt } = require('../components/UI')
  if (!canUseFeature('investment_tracking')) {
    return (
      <div>
        <PageHeader title="Investments" subtitle="Your portfolio at a glance" />
        <UpgradePrompt feature="Investment Tracking" requiredPlan="Pro" />
      </div>
    )
  }
  return (
    <div>
      <PageHeader title="Investments" subtitle="Your portfolio at a glance" />
      <Card><p style={{ color: '#6B8F7A' }}>Connect brokerage accounts to see holdings.</p></Card>
    </div>
  )
}

// CreditScore.jsx
export function CreditScore() {
  return (
    <div>
      <PageHeader title="Credit Score" subtitle="Monitor and improve your credit" />
      <Card><p style={{ color: '#6B8F7A' }}>Credit score monitoring via credit bureau API. Coming in v1.1.</p></Card>
    </div>
  )
}
